/** Under `/public` so somebody holding no role reaches it, as `ProtectedRoute` turns them away elsewhere */
export const MY_ACCOUNT_PATH = "/public/account";

export const MY_DETAILS_PATH = `${MY_ACCOUNT_PATH}/details`;

export const NOTIFICATIONS_AND_REMINDERS_PATH = `${MY_ACCOUNT_PATH}/notifications`;

export const MY_ACCOUNT_PHONE_CALENDAR_PATH = `${MY_ACCOUNT_PATH}/phone-calendar`;
